import dropdownIcon from 'assets/icons/dropdown-blue.svg';
import plusIcon from 'assets/icons/plus-blue-40.svg';
import plusIconWhite from 'assets/icons/plus-white.svg';
import accountIconWhite from 'assets/icons/shop-white.svg';
import accountIcon from 'assets/icons/shop.svg';
import { Link as BaseLink } from 'react-router-dom';
import styled, { from } from 'theme';

export const AccountsDropdownContainer = styled.div`
  height: 2.5rem;

  ${from('md')} {
    height: 4.5rem;
  }
`;

export const AccountsDropdownWrapper = styled.div`
  overflow: hidden;
  position: relative;
  z-index: ${props => props.theme.variables.zIndex.zIndexBackdrop - 1};
  margin: -0.8125rem -1rem 2rem;
  max-width: 100vw;

  ${from('md')} {
    background-color: white;
    border-radius: 2rem;
  }

  ${from('lg')} {
    margin: -0.8125rem -1.1875rem 2rem;
  }

  &.accounts-dropdown--opened {
    background-color: white;
    box-shadow: 0 0.25rem 1rem 0 rgba(0, 0, 0, 0.2);

    .accounts-dropdown__item {
      padding: 0.625rem 1.1875rem;
    }

    .accounts-dropdown__item:hover {
      background-color: ${props => props.theme.variables.customColors.green};
      color: white;

      &::before {
        background-image: url(${accountIconWhite});
      }
    }

    .accounts-dropdown__item--new:hover {
      &::before {
        background-image: url(${plusIconWhite});
      }
    }
  }

  &:not(.accounts-dropdown--opened) {
    .accounts-dropdown__item--active {
      &::after {
        content: '';
        flex: 0 0 1.875rem;
        display: inline-flex;
        margin-left: auto;
        width: 1.875rem;
        height: 1.875rem;
        background-size: contain;
        background-image: url(${dropdownIcon});
      }
    }
  }

  .accounts-dropdown__item--new {
    color: ${props => props.theme.variables.customColors.textColor};

    &::before {
      background-image: url(${plusIcon});
    }
  }
`;

export const AccountsDropdownItem = styled.div`
  padding: 0.5625rem 0.75rem 0.5625rem 1.1875rem;
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  color: ${props => props.theme.variables.customColors.lightNavy};
  cursor: pointer;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    top: 0.125rem;
  }

  &::before {
    content: '';
    position: relative;
    top: 0.125rem;
    flex: 0 0 1.375rem;
    display: inline-flex;
    margin-right: 0.75rem;
    width: 1.375rem;
    height: 1.375rem;
    margin-bottom: 0.25rem;
    background-size: contain;
    background-image: url(${accountIcon});
    background-repeat: no-repeat;
  }
`;

export const Link = styled(BaseLink)``;
